import { render, staticRenderFns } from "./GodIndex.vue?vue&type=template&id=461e6da2&scoped=true&"
import script from "./GodIndex.vue?vue&type=script&lang=js&"
export * from "./GodIndex.vue?vue&type=script&lang=js&"
import style0 from "./GodIndex.vue?vue&type=style&index=0&id=461e6da2&lang=less&scoped=true&"
import style1 from "./GodIndex.vue?vue&type=style&index=1&id=461e6da2&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "461e6da2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('461e6da2')) {
      api.createRecord('461e6da2', component.options)
    } else {
      api.reload('461e6da2', component.options)
    }
    module.hot.accept("./GodIndex.vue?vue&type=template&id=461e6da2&scoped=true&", function () {
      api.rerender('461e6da2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/god/comp/GodIndex.vue"
export default component.exports